import React, { useState, ReactNode, useEffect } from 'react';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { PolarisIcon } from '@/exports/columnCommonComponents';

type AccordionSimpleProps = {
  title: string | ReactNode;
  children: ReactNode;
  disableExpand?: boolean;
  defaultExpanded?: boolean;
  expandedCallback?: (expanded: boolean) => void;
  noPadding?: boolean;
};

const AccordionSimple: React.FC<AccordionSimpleProps> = ({
  title,
  children,
  disableExpand,
  defaultExpanded = false,
  expandedCallback,
  noPadding
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(!!defaultExpanded);

  const toggleAccordion = () => {
    if (expandedCallback) expandedCallback(!isExpanded);
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (isExpanded !== defaultExpanded) setIsExpanded(defaultExpanded);
  }, [defaultExpanded]);

  return (
    <Wrapper className="title-browser-accordion">
      <StyledExpandSection
        onClick={disableExpand ? undefined : toggleAccordion}
        expanded={+isExpanded}
        style={disableExpand ? { cursor: 'default' } : {}}
      >
        <Grid container alignItems="center" flexWrap="nowrap" sx={{ width: '100%' }}>
          {!disableExpand && <StyledIcon expanded={+isExpanded} icon="right" />}
          <Grid item sx={{ flexGrow: 2 }}>
            {title}
          </Grid>
        </Grid>
      </StyledExpandSection>
      {!disableExpand && isExpanded && !noPadding ? (
        <ContentWrapper>{children}</ContentWrapper>
      ) : !disableExpand && isExpanded && noPadding ? (
        children
      ) : (
        <></>
      )}
    </Wrapper>
  );
};

export default AccordionSimple;

const Wrapper = styled.div`
  border-radius: 4px;
  margin-bottom: 10px;

  .title-browser-accordion {
    background-color: ${({ theme }) => theme.palette.background.default};
    border: 0;
  }
  table {
    width: 100%;
  }
`;

const StyledExpandSection = styled.div<{ expanded: number }>`
  color: ${({ theme }) => theme.palette.text.primary};
  background: none;
  width: 100%;
  border: 0;
  cursor: pointer;
  outline: none;
  text-align: left;
`;

const StyledIcon = styled(PolarisIcon)<{ expanded: number }>`
  transform: ${({ expanded }) => (expanded ? 'rotate(90deg)' : 'rotate(0deg)')};
  height: ${({ theme }) => theme.spacing(3)};
  width: ${({ theme }) => theme.spacing(3)};
  opacity: 0.5;
  min-width: 30px;
  margin-right: ${({ theme }) => theme.spacing(1)};
  transition: transform 0.2s ease-in-out;
`;

const ContentWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(1, 2)};
`;
